import React, { PureComponent } from 'react';

interface TextOnlyButtonProps {
  text: string;
  value?: any;
  additionalValue?: any;
  onClick: (value?: any, additionalValue?: any) => void;
  active?: boolean;
  className: string;
}

export default class TextOnlyButton extends PureComponent<TextOnlyButtonProps> {

  render() {
    return (
      <button
        type="button"
        className={`${this.props.className} ${this.props.active ? 'btn-primary' : 'btn-text-only-inactive'} mr-2`}
        onClick={() => (!this.props.active ? this.props.onClick(this.props.value, this.props.additionalValue) : undefined)}
      >
        {this.props.text}
      </button>
    );
  }
}
